// Copyright Abridged, Inc. 2023,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - SnapshotExcluding_pk-sk-classifier-id-classifierGroup-createdTime_
 * (tsType: Omit<Snapshot, 'pk' | 'sk' | 'classifier' | 'id' |
'classifierGroup' | 'createdTime'>, schemaOptions: { exclude: [ 'pk', 'sk',
'classifier', 'id', 'classifierGroup', 'createdTime' ] })
 */
@model({
  name: 'SnapshotExcluding_pk-sk-classifier-id-classifierGroup-createdTime_',
})
export class SnapshotExcludingPkSkClassifierIdClassifierGroupCreatedTime {
  constructor(
    data?: Partial<SnapshotExcludingPkSkClassifierIdClassifierGroupCreatedTime>,
  ) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  channels?: string[];

  /**
   *
   */
  @property({
    required: true,
    jsonSchema: {
      type: 'string',
    },
  })
  space: string;
}

export interface SnapshotExcludingPkSkClassifierIdClassifierGroupCreatedTimeRelations {
  // describe navigational properties here
}

export type SnapshotExcludingPkSkClassifierIdClassifierGroupCreatedTimeWithRelations =
  SnapshotExcludingPkSkClassifierIdClassifierGroupCreatedTime &
    SnapshotExcludingPkSkClassifierIdClassifierGroupCreatedTimeRelations;
